function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAudio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "56px",
    width: "56px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECEDEF"
    },
    d: "M100.641,0c-14.139,0-25.6,11.461-25.6,25.6v460.8c0,14.139,11.461,25.6,25.6,25.6h375.467 c14.139,0,25.6-11.461,25.6-25.6V85.333L416.375,0H100.641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DCDF"
    },
    d: "M441.975,85.333h59.733L416.375,0v59.733C416.375,73.872,427.836,85.333,441.975,85.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6CACF"
    },
    d: "M399.308,42.667H75.041v153.6h324.267c4.713,0,8.533-3.821,8.533-8.533V51.2 C407.841,46.487,404.02,42.667,399.308,42.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C4DF64"
    },
    d: "M382.241,179.2H18.843c-7.602,0-11.41-9.191-6.034-14.567L75.041,102.4L12.809,40.167 C7.433,34.791,11.241,25.6,18.843,25.6h363.398c4.713,0,8.533,3.821,8.533,8.533v136.533 C390.775,175.379,386.954,179.2,382.241,179.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M322.508,102.4V85.333c0-4.713-3.821-8.533-8.533-8.533h-25.6c-4.713,0-8.533,3.821-8.533,8.533 s3.821,8.533,8.533,8.533h17.067v8.533h-8.533c-4.713,0-8.533,3.821-8.533,8.533s3.821,8.533,8.533,8.533h8.533V128h-17.067 c-4.713,0-8.533,3.821-8.533,8.533s3.821,8.533,8.533,8.533h25.6c4.713,0,8.533-3.821,8.533-8.533v-17.067 c4.713,0,8.533-3.821,8.533-8.533S327.22,102.4,322.508,102.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M262.775,76.8h-34.133c-4.713,0-8.533,3.821-8.533,8.533v51.2c0,4.713,3.821,8.533,8.533,8.533 c4.713,0,8.533-3.821,8.533-8.533v-17.067h25.6c4.713,0,8.533-3.821,8.533-8.533v-25.6C271.308,80.621,267.487,76.8,262.775,76.8z  M254.241,102.4h-17.067v-8.533h17.067V102.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M205.74,77.238c-3.488-1.164-7.322,0.036-9.526,2.976l-18.773,25.03l-18.773-25.03 c-2.203-2.939-6.039-4.138-9.526-2.976c-3.485,1.162-5.835,4.422-5.835,8.095v51.2c0,4.713,3.821,8.533,8.533,8.533 s8.533-3.821,8.533-8.533v-25.6l10.24,13.653c3.359,4.477,10.294,4.477,13.654,0l10.24-13.653v25.6 c0,4.713,3.821,8.533,8.533,8.533c4.713,0,8.533-3.821,8.533-8.533v-51.2C211.575,81.661,209.225,78.4,205.74,77.238z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6CACF"
    },
    d: "M271.308,213.333c-65.98,0-119.467,53.487-119.467,119.467s53.487,119.467,119.467,119.467 S390.775,398.78,390.775,332.8S337.288,213.333,271.308,213.333z M271.308,349.867c-9.426,0-17.067-7.641-17.067-17.067 s7.641-17.067,17.067-17.067c9.426,0,17.067,7.641,17.067,17.067S280.734,349.867,271.308,349.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3B9BF"
    },
    d: "M259.24,344.868l-72.407,72.407c21.619,21.619,51.486,34.991,84.476,34.991v-102.4 C266.595,349.867,262.329,347.956,259.24,344.868z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D9DCDF"
    },
    d: "M283.376,320.732l72.407-72.407c-21.619-21.619-51.486-34.991-84.476-34.991v102.4 C276.021,315.733,280.287,317.644,283.376,320.732z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A1A7AF"
    },
    d: "M271.308,264.533c-37.702,0-68.267,30.564-68.267,68.267s30.564,68.267,68.267,68.267 s68.267-30.564,68.267-68.267S309.01,264.533,271.308,264.533z M271.308,349.867c-9.426,0-17.067-7.641-17.067-17.067 s7.641-17.067,17.067-17.067c9.426,0,17.067,7.641,17.067,17.067S280.734,349.867,271.308,349.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8C78"
    },
    d: "M322.508,435.2c-4.713,0-8.533-3.821-8.533-8.533V307.2c0-2.917,1.49-5.633,3.952-7.2l93.867-59.733 c5.582-3.553,13.115,0.604,13.115,7.2V384c0,4.713-3.821,8.533-8.533,8.533s-8.533-3.821-8.533-8.533V263.011l-76.8,48.873v114.783 C331.041,431.379,327.22,435.2,322.508,435.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB6B5E"
    },
    d: "M313.975,426.667c0,4.713,3.821,8.533,8.533,8.533s8.533-3.821,8.533-8.533v-73.893l-17.067,9.813 V426.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB6B5E"
    },
    d: "M407.841,308.613V384c0,4.713,3.821,8.533,8.533,8.533s8.533-3.821,8.533-8.533v-85.2 L407.841,308.613z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FF8C78"
    },
    cx: 288.373,
    cy: 435.2,
    rx: 42.667,
    ry: 34.133
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB6B5E"
    },
    d: "M305.441,460.8c-23.564,0-42.667-15.282-42.667-34.133c0-9.292,4.646-17.711,12.175-23.866 c-16.985,4.502-29.242,17.301-29.242,32.399c0,18.851,19.103,34.133,42.667,34.133c11.95,0,22.746-3.935,30.492-10.268 C314.643,460.186,310.133,460.8,305.441,460.8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FF8C78"
    },
    cx: 382.24,
    cy: 384,
    rx: 42.667,
    ry: 34.133
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB6B5E"
    },
    d: "M399.308,409.6c-23.564,0-42.667-15.282-42.667-34.133c0-9.292,4.646-17.711,12.175-23.866 c-16.985,4.502-29.242,17.301-29.242,32.399c0,18.851,19.103,34.133,42.667,34.133c11.95,0,22.746-3.935,30.492-10.268 C408.51,408.986,404,409.6,399.308,409.6z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.81f67393.svg";
export { ForwardRef as ReactComponent };